import { useMemo } from 'react';
import { Offer } from '@funtech-int/yango-shared';

import { useSendWebAnalytics } from '@/shared/hooks/useSendWebAnalytics';

const CLICK_OFFER_BUTTON = 'ClickOfferButton';
const SHOW_OFFER_BUTTON = 'ShowOfferButton';
const BUY_SUBSCRIPTION_SUCCESS = 'BUY_SUBSCRIPTION_SUCCESS';

const getShowEventName = (eventAffix?: string) => {
    if (eventAffix) {
        return `${SHOW_OFFER_BUTTON}.${eventAffix}`;
    }

    return SHOW_OFFER_BUTTON;
};

const getClickEventName = (eventAffix?: string) => {
    if (eventAffix) {
        return `${CLICK_OFFER_BUTTON}.${eventAffix}`;
    }

    return CLICK_OFFER_BUTTON;
};

const getSuccessEventName = (eventAffix?: string) => {
    if (eventAffix) {
        return `${eventAffix.toUpperCase()}.${BUY_SUBSCRIPTION_SUCCESS}`;
    }

    return BUY_SUBSCRIPTION_SUCCESS;
};

function getUniversalAnalyticsEcommerceData(offer?: Offer | null) {
    if (!offer) return {};

    return {
        transactionId: offer.eventSessionId,
    };
}

export const useOfferWebAnalytics = (offer: Offer | null) => {
    const sendWebAnalytics = useSendWebAnalytics();

    return useMemo(() => {
        const eventAffix = offer?.offerTexts?.customTexts?.webAnalyticsEventAffix;

        return {
            offerShowed: () => sendWebAnalytics(getShowEventName(eventAffix)),
            offerClicked: () => sendWebAnalytics(getClickEventName(eventAffix)),
            purchaseSucceeded: () =>
                sendWebAnalytics(
                    getSuccessEventName(eventAffix),
                    getUniversalAnalyticsEcommerceData(offer)
                ),
        };
    }, [offer, sendWebAnalytics]);
};
